import { render } from "./TextButton.vue?vue&type=template&id=af1c58aa&scoped=true"
import script from "./TextButton.vue?vue&type=script&lang=js"
export * from "./TextButton.vue?vue&type=script&lang=js"

import "./TextButton.vue?vue&type=style&index=0&id=af1c58aa&scoped=true&lang=css"

import exportComponent from "/builds/sats/careers-application/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-af1c58aa"]])

export default __exports__